import { Col, Container, Row } from "reactstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const Galery = () => {

  const listGalery = [
    { name:"selleys-stick-with-it-scholarship-2025-lukas-page-margaret-mai-carpentry-joinery", img:"assets/images/gallery/gallery1.webp" },
    { name:"capstone", img:"assets/images/gallery/gallery2.webp" },
    { name:"future-of-housing-construction-centre-of-excellence-inauguration-fhccoe", img:"assets/images/gallery/gallery3.webp" },
    { name:"northern-study-hub-opening", img:"assets/images/gallery/gallery4.webp" },
    { name:"mahnaz-mohammadi-summer-campaign-2025-1", img:"assets/images/gallery/gallery5.webp" },
    { name:"worldskills-regional-competition-2024-painting-and-decorating-phoenix-boon-silver-michael-stella-bronze-annabelle-barrow-gold", img:"assets/images/gallery/gallery6.webp" },
  ]

  return (
    <section className="section" id="galery">
      <Container>
        <Row className="">
            <LightGallery
              speed={500}
              plugins={[lgThumbnail, lgZoom]}
              selector=".masonry-item"
              download={false}
            >
              <div className="masonry">
                {listGalery.map((item, id) => (
                  <a 
                    key={id} 
                    href={item.img}
                    className="masonry-item"
                  >
                    <img 
                      alt={item.name} 
                      src={item.img} 
                      className="img-fluid" 
                    />
                  </a>  
                ))}      
              </div>            
            </LightGallery>   
        </Row>
      </Container>
    </section>
  );
};

export default Galery;